"use client"
import { useMemo } from "react";
import { ChevronLeft } from "lucide-react";
import { count_units } from "@core/helpers/client/hooks/useProduct";
import { handle_attribute_separator } from "@core/helpers/string";
import Button from "@/components/ui/button";


export default function MainInfo({ data, handleScrolltTab }) {

    const features =
        useMemo(() => {
            let isImportant = [];
            data?.attribute_groups?.forEach(({ attributes }) => attributes?.forEach((item) => {
                if (item.attribute?.is_important) isImportant.push(item);
            }))

            return isImportant;
        }, [data?.attribute])

    if (!features.length) return null;

    return (
        <div>
            {features.length > 0 ?
                <>
                    <div className="flex items-center justify-between pb-3 lg:pb-0">

                        {/* h2: مستقیم زیر h1 عنوان محصول است؛ h3 یک سطح را می‌پرید (heading-order) */}
                        <h2 className="font-bold text-base text-jmt-main lg:pb-3">
                            ویژگی های اصلی
                        </h2>
                        <Button
                            onClick={() => handleScrolltTab("information")}
                            text={" مشاهده همه "}
                            end_icon={<><div className="hidden lg:flex"><ChevronLeft size={20} /></div> <div className="flex lg:hidden"><ChevronLeft size={18} /></div></>}
                            color_type="tertiary"
                            className="whitespace-nowrap"
                        />

                    </div>

                    {/* feature boxes */}
                    <div className="flex items-center overflow-x-auto lg:hidden">
                        {features.map((item, i) => {

                            let value;

                            /* if attribute toggle (type === 3)*/
                            if (item?.attribute?.type === 3) {
                                const boolVal = item?.attribute_value?.value;
                                value = item?.attribute?.options?.[boolVal ? 0 : 1]?.title;
                            }

                            /* if attribute boolean (type === 5) */
                            else if (item?.attribute?.type === 5) {
                                const key = item?.attribute_value?.value;

                                switch (key) {
                                    case "brand":
                                        value = data?.brand?.title || "-";
                                        break;
                                    case "category":
                                        value = data?.category?.title || "-";
                                        break;
                                    default:
                                        value = key || "-";
                                }
                            }

                            /* if attribute number (type === 6) */
                            else if (item?.attribute?.type === 6) {

                                let values = item?.attribute_value?.value;
                                let units = item?.attribute_value?.unit;

                                if (!Array.isArray(values)) {
                                    values = [values];
                                }

                                if (!Array.isArray(units)) {
                                    units = [units];
                                }

                                const unitTitles = units.map(u => count_units[u]?.title || "");

                                const allSameUnit = units.length > 1 && units.every(u => u === units[0]);

                                if (values.length === 1) {

                                    value = `${values[0]} ${unitTitles[0] || ""}`;
                                }
                                else if (allSameUnit) {

                                    value = `${values.join(" / ")} ${unitTitles[0]}`;
                                }
                                else {

                                    value = values
                                        .map((val, i) => `${val} ${unitTitles[i] || ""}`)
                                        .join(" / ");
                                }
                            }

                            /* if attribute (type === 4,7) */
                            else if ([4, 7].includes(item?.attribute?.type)) {

                                let values = item?.attribute_value?.value;

                                if (!Array.isArray(values)) {
                                    values = [values];
                                }

                                value = handle_attribute_separator(item?.attribute?.separator, values);
                            }

                            /* else other type */
                            else {
                                value = Array.isArray(item?.attribute_value?.value)
                                    ? item.attribute_value.value.join(" ، ")
                                    : item?.attribute_value?.value;
                            }

                            return (
                                <div
                                    key={i}
                                    className="flex flex-col justify-between items-center space-y-2 not-last:border-l border-jmt-neutral-200 px-3">
                                    <div className="text-jmt-neutral-600 text-xs">
                                        {item?.attribute?.title}
                                    </div>

                                    <div className="text-jmt-main font-bold text-sm truncate">
                                        {value}
                                    </div>
                                </div>
                            );
                        })}

                    </div>

                    <div className="hidden lg:grid lg:grid-cols-2 lg:gap-6">
                        {features.map((item, i) => {

                            let value;

                            /* if attribute toggle (type === 3)*/
                            if (item?.attribute?.type === 3) {
                                const boolVal = item?.attribute_value?.value;
                                value = item?.attribute?.options?.[boolVal ? 0 : 1]?.title;
                            }

                            /* if attribute boolean (type === 5) */
                            else if (item?.attribute?.type === 5) {
                                const key = item?.attribute_value?.value;

                                switch (key) {
                                    case "brand":
                                        value = data?.brand?.title || "-";
                                        break;
                                    case "category":
                                        value = data?.category?.title || "-";
                                        break;
                                    default:
                                        value = key || "-";
                                }
                            }

                            /* if attribute number (type === 6) */
                            else if (item?.attribute?.type === 6) {

                                let values = item?.attribute_value?.value;
                                let units = item?.attribute_value?.unit;

                                if (!Array.isArray(values)) {
                                    values = [values];
                                }

                                if (!Array.isArray(units)) {
                                    units = [units];
                                }

                                const unitTitles = units.map(u => count_units[u]?.title || "");

                                const allSameUnit = units.length > 1 && units.every(u => u === units[0]);

                                if (values.length === 1) {

                                    value = `${values[0]} ${unitTitles[0] || ""}`;
                                }
                                else if (allSameUnit) {

                                    value = `${values.join(" / ")} ${unitTitles[0]}`;
                                }
                                else {

                                    value = values
                                        .map((val, i) => `${val} ${unitTitles[i] || ""}`)
                                        .join(" / ");
                                }
                            }

                            /* if attribute (type === 4,7) */
                            else if ([4, 7].includes(item?.attribute?.type)) {

                                let values = item?.attribute_value?.value;

                                if (!Array.isArray(values)) {
                                    values = [values];
                                }

                                value = handle_attribute_separator(item?.attribute?.separator, values);
                            }

                            /* else other type */
                            else {
                                value = Array.isArray(item?.attribute_value?.value)
                                    ? item.attribute_value.value.join(" ، ")
                                    : item?.attribute_value?.value;
                            }

                            return (
                                <div
                                    key={i}
                                    className="flex flex-col justify-between space-y-2"  >
                                    <div className="text-jmt-neutral-600 text-xs">
                                        {item?.attribute?.title}
                                    </div>

                                    <div className="text-jmt-main font-bold text-sm border-b border-jmt-neutral-200 pb-1 truncate">
                                        {value}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </>
                : ""}


        </div>
    );
}
